import { useDialogContext } from '@/components/contexts/ModalContext';
import { Trans } from '@lingui/macro';
import { Dialog, DialogContent, DialogTitle, Text } from '@luminovo/design-system';
import { UpdateUserRoleForm } from './UpdateUserRoleForm';

export interface EditUserRoleDialogProps {
    userId: string;
}

export function useEditUserRoleDialog() {
    const { setDialog, closeDialog } = useDialogContext();

    const openDialog = ({ userId }: EditUserRoleDialogProps) => {
        const dialog = (
            <Dialog open={true} onClose={() => closeDialog()} fullWidth maxWidth={'sm'}>
                <DialogTitle
                    title={
                        <Text variant="h2">
                            <Trans>Edit user additional role</Trans>
                        </Text>
                    }
                    onClose={() => closeDialog()}
                />
                <DialogContent style={{ paddingBottom: 24 }}>
                    <UpdateUserRoleForm userId={userId} closeDialog={closeDialog} />
                </DialogContent>
            </Dialog>
        );

        setDialog(dialog);
    };

    return {
        openDialog,
        closeDialog,
    };
}
